export default __webpack_public_path__ + "static/media/88mph.f5ed351a.jpg";